/**
 * FAQ Header Handler
 * Adds margin-top to main section when hcUrl parameter has content beyond base locale
 * Continuously monitors URL changes for dynamic navigation
 */
(function() {
  let currentState = {
    hasExtendedContent: false,
    isMarginApplied: false
  };

  // Function to check current page state
  function checkPageState() {
    const urlParams = new URLSearchParams(window.location.search);
    const hcUrlParam = urlParams.get('hcUrl');
    
    // Check if hcUrl parameter exists and has content beyond the base locale
    let hasExtendedContent = false;
    
    if (hcUrlParam) {
      // Decode the URL parameter to check its content
      const decodedHcUrl = decodeURIComponent(hcUrlParam);
      
      // Check if it's more than just the base locale patterns
      // Common base patterns: /en-US, /fr-FR, /es-ES, etc.
      const isJustLocale = /^\/[a-z]{2}-[A-Z]{2}$/.test(decodedHcUrl);
      
      // If it's not just a locale, it has extended content
      hasExtendedContent = !isJustLocale && decodedHcUrl.length > 0;
    }
    
    return {
      hasExtendedContent: hasExtendedContent,
      shouldApplyMargin: hasExtendedContent
    };
  }

  // Function to apply margin to main section
  function applyMainMargin() {
    if (currentState.isMarginApplied) return; // Already applied
    
    // Add body class to trigger CSS rules
    document.body.classList.add('has-articles-param');
    
    // Find main section and apply margin
    const mainSection = document.querySelector('main') || 
                       document.querySelector('.main') || 
                       document.querySelector('#main') ||
                       document.querySelector('[role="main"]') ||
                       document.querySelector('.page-width').parentElement ||
                       document.querySelector('.shopify-section').parentElement;

    
    currentState.isMarginApplied = true;
    console.log('hcUrl parameter has extended content beyond base locale - padding applied to main section');
  }

  // Function to remove margin from main section
  function removeMainMargin() {
    if (!currentState.isMarginApplied) return; // Already removed
    
    // Remove body class
    document.body.classList.remove('has-articles-param');
    
    // Find main section and remove margin
    const mainSection = document.querySelector('main') || 
                       document.querySelector('.main') || 
                       document.querySelector('#main') ||
                       document.querySelector('[role="main"]') ||
                       document.querySelector('.page-width').parentElement ||
                       document.querySelector('.shopify-section').parentElement;
    
    if (mainSection) {
      mainSection.style.marginTop = '';
    }
    
    currentState.isMarginApplied = false;
    console.log('Padding removed from main section');
  }

  // Function to handle state changes
  function handleStateChange() {
    const newState = checkPageState();
    
    // Update current state
    currentState.hasExtendedContent = newState.hasExtendedContent;
    
    if (newState.shouldApplyMargin && !currentState.isMarginApplied) {
      applyMainMargin();
    } else if (!newState.shouldApplyMargin && currentState.isMarginApplied) {
      removeMainMargin();
    }
  }

  // Function to set up URL monitoring
  function setupURLMonitoring() {
    // Initial check
    handleStateChange();

    // Monitor URL changes (for pushState/replaceState navigation)
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function() {
      originalPushState.apply(history, arguments);
      setTimeout(handleStateChange, 10); // Small delay to ensure URL is updated
    };

    history.replaceState = function() {
      originalReplaceState.apply(history, arguments);
      setTimeout(handleStateChange, 10);
    };

    // Monitor popstate events (back/forward navigation)
    window.addEventListener('popstate', function() {
      setTimeout(handleStateChange, 10);
    });

    // Monitor hash changes
    window.addEventListener('hashchange', handleStateChange);

    // Monitor URL parameter changes with a periodic check as fallback
    let lastUrl = window.location.href;
    setInterval(function() {
      const currentUrl = window.location.href;
      if (currentUrl !== lastUrl) {
        lastUrl = currentUrl;
        handleStateChange();
      }
    }, 1000); // Check every second
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupURLMonitoring);
  } else {
    setupURLMonitoring();
  }
})();
